<template>
    <Overlay :show="runtimeState.isSaving">
        <InstructionText v-if="settings.showInstruction">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="$t('Page(ReceivedRequest):Component(Instruction):other-information')" />
        </InstructionText>

        <LegacyOtherReplyInformation
            ref="legacyStep"
            :request="context.request"
            @validityChange="handleValidityChange"
            @input="handleInput"
        />
    </Overlay>
</template>

<script>
import InstructionText from '@core/components/common/instructions/InstructionText.vue'
import Overlay from '@core/components/common/Overlay.vue'
import LegacyOtherReplyInformation from '@/views/request/received/components/send-reply/OtherReplyInformation.vue'

export default {
    name: 'OtherInformationStep',
    components: {
        InstructionText,
        LegacyOtherReplyInformation,
        Overlay,
    },
    props: {
        context: { type: Object, required: true },
        settings: { type: Object, required: true },
        runtimeState: { type: Object, required: true },
    },
    mounted() {
        this.synchronizeLegacyState()
    },
    methods: {
        synchronizeLegacyState() {
            const { legacyStep } = this.$refs
            if (!legacyStep) {
                return
            }

            const information = this.context.request.otherInformation || {}
            legacyStep.internalComment = information.internalComment || null
            legacyStep.customerInformation = information.customerInformation || null
            legacyStep.declarationValidity = information.declarationValidity || null

            const validity = legacyStep.$refs && legacyStep.$refs.DeclarationValidity
            if (legacyStep.declarationValidity) {
                if (validity && typeof validity.setValueByMonth === 'function') {
                    const month = typeof legacyStep.declarationValidity === 'object'
                        ? legacyStep.declarationValidity.month
                        : legacyStep.declarationValidity
                    validity.setValueByMonth(month)
                }
                legacyStep.emitValidity()
            } else if (validity && typeof validity.setDefault === 'function') {
                validity.setDefault()
            } else {
                legacyStep.emitValidity()
            }
        },
        handleValidityChange(isValid) {
            this.$emit('validity-change', { isValid, errors: [] })
        },
        handleInput(otherInformation) {
            this.$emit('action', {
                type: 'other-information.change',
                payload: { otherInformation },
            })
        },
    },
}
</script>
